import styled from 'styled-components';

const StyledInvoicePreviewWithIcon = styled.span`
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;

export {
  StyledInvoicePreviewWithIcon
}
